import axios from "axios";
import { LogInResponse } from "types/responses/LogInResponse";
import { ResponseError } from "types/responses/ResponseError";
import { UserI } from "types/UserI";
import { getHeaders } from "../AuthHeader";

const API_URL = process.env.REACT_APP_API_URL;

export async function getUser() {
    
    try {
        
        // console.log("Get User function");
        
        const response = await axios.get(
            API_URL + '/user', 
            { headers: getHeaders() });
        
        // console.log('get User'.toUpperCase());
            
        // console.log(response);

                
        if ('error' in response.data) {    
            // console.log("error");
            return response.data.error
        }
        
        if (!('user' in response.data)) {
            throw Error
        }
        
        const json:LogInResponse = JSON.parse(response.data.user)
        // console.log("json");
        // console.log(json);
        
        
        let user: UserI = {
            client_id: json.ID_KLIENT || '-1',
            connection_id: json.ID_PRIHLASENI || '-1',
            credits: json.KREDIT || '0',
            email: json.EMAIL || '',
            first_name: json.JMENO || '',
            second_name: json.PRIJMENI || '',
            phone: json.TEL_MOB || '',
            address: [json.ADRESA_1, json.ADRESA_2, json.ADRESA_3, json.ADRESA_4],
            birth_date: json.DAT_NAR,
            membership: null
        }   
        // console.log(user);
        

        return user
    }
    catch(error) {
        
        // console.log("catch error");
        // console.log(error);
        
        return ResponseError.general_error
    }
}

export async function getUserEmail(client_id: any) {
    try {
        const response = await axios.get(
            API_URL + '/user_email', 
            {
                params: {
                    client_id: client_id
                }
            }
        )

        if ('error' in response.data) {
            return response.data.error
        }

        if (!('user' in response.data)) {
            return "get_user_email_not_user_error"
        }  

        const json = JSON.parse(response.data.user)

        let user = {
            client_id: json.ID_KLIENT || '-1',
            email: json.EMAIL || '',
        }

        return user

    } catch (error) {
        return "get_user_email_error"
    }
}